<template>
  <div class="p-loading"></div>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>
